<template lang="jade">
  li(v-on:click="selectMe")
    label {{ value }}
</template>

<script>
import { getWithDotNotation } from '../../utils'

export default {
  props: {
    useState: {type: String, required: true},
    field: {type: String, required: true},
    item: {type: Object, required: true},
    parseField: {type: Function},
    onChange: {type: Function}
  },
  computed: {
    value () {
      if (this.parseField) {
        return this.parseField(this.item[this.field])
      } else {
        return getWithDotNotation(this.item, this.field)
      }
    }
  },
  methods: {
    async selectMe () {
      this.$dispatchUseState(this.useState, {selected: this.item})
      if (this.onChange) { this.onChange(this.item) }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ItemSelector.vue?d54062f6